var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("p", { staticClass: "text-sm text-gray-500" }, [
    _vm._v(" " + _vm._s(_vm.message) + " "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }